import { gql, useQuery } from "@apollo/client";
import { Button, Card, Col, Divider, Image, Layout, Menu, Row, Tag } from "antd";
import Text from "antd/lib/typography/Text";
import Title from "antd/lib/typography/Title";
import { useApplicationContext } from "components/Application";
import { CenterResult } from "components/CenterResult";
import { CenterSpinner } from "components/CenterSpinner";
import React, { Fragment } from "react";
import { NavLink, useParams } from "react-router-dom";

const collectionSeasonQuery = gql`
  query ($id: ID!) {
    collectionSeason(id: $id) {
      id
      code
      nameEn
      kindEn
      isEnabled
      isStock
      shippingWindow
      shippingExpected
      topItems {
        item {
          id
          nameEn
          shortDescriptionEn
          cover
          color {
            code
            nameEn
            patch
          }
          line {
            id
            nameEn
          }
        }
        quantity
      }
    }
  }
`;

export const Show: React.FC<{}> = () => {
  const {
    siteEnvironment: { appEndpointStore },
  } = useApplicationContext();

  const { id } = useParams();

  const {
    error,
    loading: queryLoading,
    data,
  } = useQuery(collectionSeasonQuery, {
    variables: { id },
    fetchPolicy: "cache-and-network",
  });

  const resource = data?.collectionSeason;

  if (queryLoading) return <CenterSpinner size="large" />;
  if (error)
    return (
      <CenterResult
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <NavLink to="../../">
            <Button type="primary">Back to list</Button>
          </NavLink>
        }
      />
    );

  return (
    <Fragment>
      <Layout.Header className="header-background">
        <Row justify="space-between">
          <Menu theme="light" mode="horizontal">
            <Menu.Item className="no-border">
              <Title level={4} style={{ lineHeight: "auto" }}>
                Season {resource.code}
              </Title>
            </Menu.Item>
          </Menu>
          <Menu theme="light" mode="horizontal">
            <Menu.Item className="no-border no-margin">
              <NavLink to="../">
                <Button>Back</Button>
              </NavLink>
            </Menu.Item>
            <Menu.Item className="no-border">
              <NavLink to="./edit">
                <Button type="primary">Edit</Button>
              </NavLink>
            </Menu.Item>
          </Menu>
        </Row>
      </Layout.Header>
      <Layout className="content">
        <Layout.Content className="content">
          <Card>
            <Row gutter={[25, 0]}>
              <Col>
                <Text>Name: {resource.nameEn}</Text>
              </Col>
              <Col>
                <Text>Kind: {resource.kindEn}</Text>
              </Col>
              <Col>
                <Text>Shipping Window: {resource.shippingWindow}</Text>
              </Col>
              <Col>
                <Text>Shipping Expected: {resource.shippingExpected}</Text>
              </Col>
              <Col>{resource.isEnabled ? <Tag color="green">ENABLED</Tag> : <Tag color="volcano">DISABLED</Tag>}</Col>
              <Col>
                <Text>{resource.isStock ? "Stock" : "Seasonal"}</Text>
              </Col>
            </Row>
            <Divider />
            <Row gutter={[25, 25]}>
              <Col>
                <Title level={5}>Top 5 ordered items</Title>
              </Col>
            </Row>
            {resource.topItems?.map((topItem: any, i: any) => {
              const { item } = topItem;
              return (
                <Row gutter={[25, 25]} key={i}>
                  <Col span={4}>
                    <Image src={`${appEndpointStore}${item.cover}`} width={100} />
                  </Col>
                  <Col span={8}>
                    <b>{item.nameEn}</b>
                    <br />
                    {item.shortDescriptionEn}
                  </Col>
                  <Col span={4}>
                    <Image src={`${appEndpointStore}${item.color.patch}`} width={20} height={20} /> {item.color.code} -{" "}
                    {item.color.nameEn}
                  </Col>
                  <Col span={4}>Line: {item.line?.nameEn}</Col>
                  <Col span={4}>Qty: {topItem.quantity}</Col>
                </Row>
              );
            })}
          </Card>
        </Layout.Content>
      </Layout>
    </Fragment>
  );
};
